<mat-form-field
    class="kh-chip-multiselect-field"
    [subscriptSizing]="subscriptSizing"
>
    <mat-select
        [(ngModel)]="value"
        [disabled]="isDisabled"
        [ngModelOptions]="{ standalone: true }"
        [placeholder]="placeholder"
        multiple
        disableOptionCentering
        (selectionChange)="onSelectionChange()"
    >
        <mat-select-trigger>
            <mat-chip-set>
                @for (item of displayedChipValues; track item) {
                    <mat-chip (removed)="remove(item)">
                        {{ getOptionText(item) }}
                        <button
                            matChipRemove
                            (click)="$event.stopPropagation()"
                            [attr.aria-label]="'Remove ' + getOptionText(item)"
                        >
                            <mat-icon>cancel</mat-icon>
                        </button>
                    </mat-chip>
                }
            </mat-chip-set>
        </mat-select-trigger>
        @for (option of orderedOptions; track option.id) {
            <mat-option [value]="option.id">
                {{ option.text }}
                @if (option.id === summaryOptionId) {
                    <mat-icon>folder_copy</mat-icon>
                }
            </mat-option>
            @if (option.id === summaryOptionId) {
                <mat-divider></mat-divider>
            }
        }
    </mat-select>
</mat-form-field>
